import React, { useState, useEffect } from "react";
import Navigationbar from './Navigationbar';
import '../Pages/Settings/SubNavbar.css';
import EmailAddresses from './Settings/EmailAddresses';
import SmsNotificationSettings from './Settings/TrueThreatSmsSettings';
import WhatInfo from './Settings/WhatInfo';
import ScheduledTime from './Settings/ScheduledTime';
import CreateRecordPolicyTemplate from './SystemManager/HealthPolicyTemplate';
import CapacityDashboard from './SystemManager/CapacityDashboard';
import TenantAndSecretKeyInfo from './SystemManager/TenantAndSecretKeyInfo';
import PagingSession from './SystemManager/PagingSession';
import { useLocation } from "react-router-dom";
import { Tabs, Tab, Box, Typography, useMediaQuery } from "@mui/material";
import { getFreshToken } from '../custom_libraries/serverRequests';
// import DeviceSpecificNotifications from './Settings/DeviceSpecificNotifications';
// import CloudStorageTemplates from './Settings/CloudStorageTemplates';
import CloudStorageTemplates from './Settings/CloudStorageTemplates';
import globalVariables from '../custom_libraries/globalVariables';
import RocketChatSettings from './Settings/RocketChatSettings';

// Main component for Settings page

//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      // default: "#0d0d0d",
      // paper: "#000000",
      default: "#191e29",
      paper: "#2e3442",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
});
//------------------------------------------

const Settings = () => {
  const [activeMainTab, setActiveMainTab] = useState(0); // Main tab index
  const [activeSubTab, setActiveSubTab] = useState(0); // Subtab index
  const [smsServicePermission, setSmsServicePermission] = useState(localStorage.getItem(globalVariables.SMS_SERVICE_PERMISSION) === "true" || false); // State for SMS service permission
  const isMobile = useMediaQuery('(max-width: 768px)');

    useEffect(() => {
      validateSignedIn() 
    }, []);

  const validateSignedIn = async () => {
      let is_fresh_token = await getFreshToken()
        // const smsServicePermission = localStorage.getItem(globalVariables.SMS_SERVICE_PERMISSION);
      if (!is_fresh_token) {
          window.location.replace("/");
          return
      }
  }
  const userType = localStorage.getItem(globalVariables.USER_TYPE);
 // Convert to boolean
  // Dynamically build the Notification subtabs based on permission
  const notificationSubtabs = ["Email Address"];
  const notificationContent = [<EmailAddresses />];

  if (smsServicePermission === true) {
    notificationSubtabs.push("SMS Notifications");
    notificationContent.push(<SmsNotificationSettings />);
  }

  // Always append the trailing subtabs
  notificationSubtabs.push("What Info", "AI Engine");
  notificationContent.push(<WhatInfo />, <ScheduledTime />);

  // Main tab content
  const mainTabs = [
    {
      label: "Notification Settings",
      subtabs: notificationSubtabs,
      content: notificationContent,

    },
    {
      label: "Recording Template Settings",
      // subtabs: ["Create Record Policy Template"],
      content: [<CreateRecordPolicyTemplate />],
    },
    // {
    //   label: "Cloud Storage Template",
    //   // subtabs: ["Create Cloud Storage Template"],
    //   content: [<CloudStorageTemplates />],
    // },
    {
      label: "Server Capacity   ",
      content: [<CapacityDashboard />],
    },
    {
      label: "Rocket Chat Settings",
      content: [<RocketChatSettings />],
    },
   ...(userType === "DealerUser"
    ? [
        {
          label: "Paging Session",
          content: [<PagingSession />],
        },

        {
          label: "Tenant ID and Secret key",
          content: [<TenantAndSecretKeyInfo />],
        }
      ]
    : []),
  ];

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Box
        sx={{
          height: '100vh',
          overflow: 'hidden',
          '@media (max-width: 768px)': {
            minHeight: '100dvh',
            height: 'auto',
            overflowX: 'hidden',
            overflowY: 'auto',
          },
        }}
      >
        {/* Navigation Bar */}
        <Navigationbar /> &emsp;
        <Box
          sx={{
            marginLeft: '3%',
            minWidth: 0,
            '@media (max-width: 768px)': {
              marginLeft: '20px',
              width: '100%',
            },
          }}
        >
          {/* Main Tabs */}
          <Box
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              ml: 10,
              backgroundColor: '#2c2c2c',
              minWidth: 0,
              '@media (max-width: 768px)': {
                ml: 0,
                width: '100%',
              },
            }}
          >
          <Tabs
            value={activeMainTab}
            onChange={(e, newValue) => {setActiveMainTab(newValue);
              setActiveSubTab(0); // Reset subtab when switching main tabs
            }}
            
            textColor="white"
            indicatorColor="primary"
            variant={isMobile ? 'scrollable' : 'standard'}
            scrollButtons={isMobile ? 'auto' : false}
            allowScrollButtonsMobile={isMobile}
            // centered
          >
            {mainTabs.map((tab, index) => (
              <Tab key={index} label={tab.label}
              sx={{
                "&.Mui-selected": {
                  backgroundColor: "#757f8a",
                  fontWeight: 550,
                },
              }}
              />
            ))}
          </Tabs>

          </Box>

          {/* Conditional Rendering for Subtabs */}
          {mainTabs[activeMainTab].subtabs ? (
            <Box
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
                mt: 2,
                ml: 10,
                minWidth: 0,
                '@media (max-width: 768px)': {
                  ml: 0,
                  width: '100%',
                },
              }}
            >
              <Tabs
                value={activeSubTab}
                onChange={(e, newValue) => setActiveSubTab(newValue)}
                textColor="black"
                variant={isMobile ? 'scrollable' : 'standard'}
                scrollButtons={isMobile ? 'auto' : false}
                allowScrollButtonsMobile={isMobile}
              >
                {mainTabs[activeMainTab].subtabs.map((subTab, index) => (
                  <Tab key={index} label={subTab} />
                ))}
              </Tabs>
            </Box>
          ) : null}

          {/* Tab Content */}
          <Box sx={{ p: 3, minWidth: 0, '@media (max-width: 768px)': { p: 1.5 } }}>
            <Typography component="div" sx={{ minWidth: 0 }}>
              {mainTabs[activeMainTab].subtabs
                ? mainTabs[activeMainTab].content[activeSubTab]
                : mainTabs[activeMainTab].content}
            </Typography>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default Settings;
